import "../css/moodboard-masonry.css";
import ReactPlayer from "react-player";
import ItemBar from "./ItemBar/ItemBar";

import styled from "styled-components";
const StyledReactPlayer = styled(ReactPlayer)`
  &.custom-player {
    min-width: calc(100vw / 5) !important;
    width: 100% !important;
    /* height: 100% !important; */
    video {
      /* min-width: calc(100vw / 3) !important; */
      min-height: 300px !important;
    }

    iframe {
      min-width: calc(100vw / 3) !important;
      min-height: 300px !important;
    }

    @media screen and (min-width: 1440px) {
      min-width: calc(100vw / 5) !important;

      video {
        min-width: calc(100vw / 5) !important;
      }

      iframe {
        min-width: calc(100vw / 5) !important;
      }
    }
  }
  /* @media screen and (min-width: 1440px) {
      min-width: calc(100vw / 5) !important;

      video {
        min-width: calc(100vw / 5) !important;
      }

      iframe {
        min-width: calc(100vw / 5) !important;
      }
    } */
`;
const renderVideo = (currentFile, src, isInnerView) => {
  // Uploaded videos have no poster frame of their own, so without this the tile
  // renders as a blank black rectangle until the user hits play.
  const thumbnail = currentFile?.thumbnailUrl;
  const playerConfig = thumbnail
    ? { file: { attributes: { poster: thumbnail, preload: "metadata" } } }
    : undefined;

  if (src.includes("tiktok")) {
    if (src.includes("embed")) {
      return <iframe className="player-yt" src={src} allow="fullscreen" />;
    }
    const videoId = src.split("/").pop();
    const embedUrl = `https://www.tiktok.com/embed/${videoId}`;
    return <iframe className="player-yt" src={embedUrl} allow="fullscreen" />;
  }
  if (currentFile?.width && isInnerView) {
    return (
      <StyledReactPlayer
        className="custom-player"
        url={src}
        controls={true}
        width={currentFile.width}
        config={playerConfig}
      />
    );
  } else {
    return (
      <ReactPlayer
        className={isInnerView ? "inner-view-video" : "player-yt"}
        url={src}
        controls={true}
        config={playerConfig}
      />
    );
  }
};

function TileVideo({
  currentFile,
  view,
  rateAssetService,
  isInnerView,
  ...props
}) {
  return (
    <div className={`tile ${props.id}`}>
      <ItemBar
        currentFile={currentFile}
        viewItem={() => view(currentFile._id)}
        deleteItem={() => props.delete(currentFile._id)}
        rateAssetService={rateAssetService}
      />
      {/* <ReactJWPlayer
        className="player"
        playerId={props.id.toString()}
        playerScript="https://cdn.jwplayer.com/libraries/s7lNp89j.js"
        file={props.src}
        image={
          props.image
            ? props.image.replace("h=630", "h=200").replace("w=1200", "w=350")
            : null
        }
      /> */}
      {renderVideo(currentFile, props.src, isInnerView)}
    </div>
  );
}

export default TileVideo;
